import {observer} from "mobx-react-lite"
import React from "react"
import "./destination.sass"
import {Field, Select as SelectS} from "../../lib/wa-2.0"
import Rule, {IRuleUnitOption} from "../../store/entities/rules/Rule";
import {RuleDescription} from "./RuleDescription";
import {AsyncRuleInputSelection} from "./AsyncRuleInputSelection";
import NameTemplateRule from "../../store/entities/rules/NameTemplateRule";
import ReactTooltip from "react-tooltip";
import {Link, useHistory} from "react-router-dom"
import Select from "react-select";
import {selectStyler} from "../SelectStyler";
import classNames from "classnames";
import {appPages} from "../../App";
import exportStatusController from "../../pages/exportHistory/ExportStatusController"
import controller from "../../store/pageControllers/PriceUpdateController"

export const RuleComponent = observer((
    {rule, fieldLabelClasses, onMouseEnterInput}:
        {
            rule: Rule,
            fieldLabelClasses?: string
            onMouseEnterInput?: () => void
        }) => {
    const fieldLabel = (
        <span className={fieldLabelClasses}>
            {rule.name} {rule.ozon_attribute_id && <span style={{fontSize:'10px'}}>({rule.ozon_attribute_id})</span>} {rule.is_required && <span style={{color: "var(--red)"}}>*</span>}
            <RuleDescription rule={rule}/>
        </span>
    )

    const history = useHistory();
    const handlePropsLinkClick = (e: any, rule: Rule) => {
        e.preventDefault()
        // console.log(rule)
        if(rule && rule.isInputExist) {
            rule.setInputRule().then(() => {
                history.push(appPages.offerAttributes + '/category/' + rule.category_id + '/attribute/' + rule.ozon_attribute_id)
            })
        }

    }


    const isDev = !!getCookie('dev');

    return <div>
        <Field classes={["custom-my-8", "attr-field", "ruleField"]} label={fieldLabel}>
            <div className={'flexbox middle'}>
                <div className={'custom-mr-8'}>
                    <i className="fa fa-arrow-right" aria-hidden="true"/>
                </div>

                {(isDev && (rule.exampleValue || rule.input.isLoading)) && <ExampleValue rule={rule}/>}

                <div className={"custom-ml-32 flexbox width-60"}
                     data-tip={''}
                     onMouseEnter={isDev ? onMouseEnterInput : undefined}
                     data-for={'valueChecker' + rule.ozon_attribute_id + rule.type}>
                    <div className={classNames(!!rule.input.input_unit_options ? 'width-70' : "width-100")}>
                        <AsyncRuleInputSelection rule={rule}/>
                    </div>
                    <div className="custom-ml-4">
                        {rule.input.input_unit_options && <Select<IRuleUnitOption>
                            {...selectStyler}
                            value={rule.input.input_unit_option}
                            options={rule.input.input_unit_options}
                            onChange={(value) => {
                                if (value) {
                                    rule.input.input_unit_option = value
                                }
                            }
                            }
                        />}
                    </div>

                </div>
            </div>

            {rule.type === "ozonOutputDictionaryPairAttribute" && <div className={'goToValueCompare'}>
                <Link
                    to={rule.isInputExist ? appPages.offerAttributes + '/category/' + rule.category_id + '/attribute/' + rule.ozon_attribute_id
                        : appPages.offerAttributes + '/category/' + rule.category_id}
                    style={{color: rule.isInputExist ? "" : "red"}}
                    data-tip={true}
                    data-for={rule.category_id + "" + rule.ozon_attribute_id}
                    onClick={(e) => handlePropsLinkClick(e, rule)}
                > Сопоставить значения</Link>
                {!rule.isInputExist &&
                <ReactTooltip id={rule.category_id + "" + rule.ozon_attribute_id}>
                    Не выбрана характеристика
                </ReactTooltip>}
            </div>}
        </Field>
        {rule.markups &&
        <Field classes={["custom-my-8", "attr-field", "ruleField"]} label={'Наценка'}>
            <div className={'flexbox middle'} style={{display: 'inline-block'}}>
                <div className={'field-box'}>
                    { rule.markups.length > 0 ?
                        rule.markups.map((markup, index) => <div className={'price-fields'} key={index}>
                            <div className={'add-price-fields-group'}>
                                <div className={'add-price-field'}>
                                    <input
                                        value={markup.from.source_value}
                                        onChange={e => {
                                            if (e.target.value) {
                                                markup.from.source_value = e.target.value
                                                markup.from.source_type = 'SPECIFIC'
                                            } else {
                                                markup.from.source_value = e.target.value
                                                markup.from.source_type = 'IS_EMPTY'
                                            }
                                            rule.setMarkupRule()
                                        }}
                                        placeholder="От"
                                        className={'input-text'}
                                    />
                                </div>
                                <div className={'price-fields-sign'}>
                                    -
                                </div>
                                <div className={'add-price-field'}>
                                    <input
                                        value={markup.to.source_value}
                                        onChange={e => {
                                            if (e.target.value) {
                                                markup.to.source_value = e.target.value
                                                markup.to.source_type = 'SPECIFIC'
                                            } else {
                                                markup.to.source_value = e.target.value
                                                markup.to.source_type = 'IS_EMPTY'
                                            }
                                            rule.setMarkupRule()
                                        }}
                                        placeholder="До"
                                        className={'input-text'}
                                    />
                                </div>
                            </div>
                            <div className={'add-price-fields-group'}>
                                <div className={'price-fields-sign'}>
                                    +
                                </div>
                                <div className={'add-price-field'}>
                                    <input
                                        value={markup.additional_price.source_value}
                                        onChange={e => {
                                            if (e.target.value) {
                                                markup.additional_price.source_value = e.target.value
                                                markup.additional_price.source_type = 'SPECIFIC'
                                            } else {
                                                markup.additional_price.source_value = e.target.value
                                                markup.additional_price.source_type = 'IS_EMPTY'
                                            }
                                            rule.setMarkupRule()
                                        }}
                                        placeholder="0"
                                        className={'input-text'}
                                    />
                                </div>

                                <div className={'add-price-type-field'}>
                                    <SelectS
                                        className={""}
                                        options={controller.units}
                                        value={markup.additional_price_currency}
                                        onChange={(e) => {
                                            markup.additional_price_currency = e.target.value
                                            rule.setMarkupRule()
                                        }}
                                    />
                                </div>
                            </div>
                            <div className={'add-price-fields-group'} style={{marginLeft:'40%'}}>
                                <div className={'price-fields-sign'}>
                                    +
                                </div>
                                <div className={'add-price-field'}>
                                    <input
                                        value={markup.additional_price2.source_value}
                                        onChange={e => {
                                            if (e.target.value) {
                                                markup.additional_price2.source_value = e.target.value
                                                markup.additional_price2.source_type = 'SPECIFIC'
                                            } else {
                                                markup.additional_price2.source_value = e.target.value
                                                markup.additional_price2.source_type = 'IS_EMPTY'
                                            }
                                            rule.setMarkupRule()
                                        }}
                                        placeholder="0"
                                        className={'input-text'}
                                    />
                                </div>
                                <div className={'add-price-type-field'}>
                                    <SelectS
                                        className={""}
                                        options={controller.units}
                                        value={markup.additional_price_currency2}
                                        onChange={(e) => {
                                            markup.additional_price_currency2 = e.target.value
                                            rule.setMarkupRule()
                                        }}
                                    />
                                </div>
                                <a
                                    onClick={() => {
                                        rule.deleteMarkup(index)
                                    }}
                                >
                                    <i className="fa fa-minus" aria-hidden="true"/>
                                </a>
                            </div>
                        </div>) :
                        <a
                            onClick={() => {
                                rule.addMarkup()
                            }}
                        >
                            <i className="fa fa-plus" aria-hidden="true"/> <span style={{borderBottom: '1px dashed'}}>Добавить</span>
                        </a>
                    }
                </div>
                {rule.markups.length > 0 &&
                <div className={'field-box'}>
                    <a
                        className={''}
                        onClick={() => {
                            rule.addMarkup()
                        }}
                    >
                        <i className="fa fa-plus" aria-hidden="true"/> <span style={{borderBottom: '1px dashed'}}>Добавить</span>
                    </a>
                </div>
                }
            </div>
        </Field>}
        {rule instanceof NameTemplateRule && <AdditionalNameRules rule={rule}/>}
    </div>
})
declare var backend_url: string;

function ExampleValue({rule}: { rule: Rule }) {
    return <ReactTooltip
        className="extraClass"
        place={'right'}
        id={'valueChecker' + rule.ozon_attribute_id + rule.type}
        effect="solid"
        delayHide={500}
    >{rule.exampleValue ? <>
        <div>
            {rule.exampleValue.product_name && <div>Товар: <a
                target={'_blank'}
                rel="noopener noreferrer"
                href={backend_url + 'shop/?action=products#/product/' + rule.exampleValue.product_id}
            >{rule.exampleValue.product_name}</a></div>}
        </div>
        <div>
            {rule instanceof NameTemplateRule ? <><a
                target={'_blank'}
                rel="noopener noreferrer"
                href={backend_url + 'shop/?action=products#/product/' + rule.exampleValue.product_id}
            >{rule.exampleValue.text}</a></> : <>Значение: {rule.exampleValue.text}</>}

        </div>
    </> : "Загрузка"}</ReactTooltip>
}

function AdditionalNameRules({rule}: { rule: NameTemplateRule }) {
    return <>
        {rule.child_rules.map((rule, index) => <RuleComponent key={index} rule={rule}
                                                              fieldLabelClasses={'custom-pl-16'}/>)}
    </>
}

function getCookie(name: string) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        const part = parts.pop();
        if (part) {
            return part.split(';').shift()
        }
    }
}